import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ButtonBase from "@mui/material/ButtonBase";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import { useTranslation } from "react-i18next";
import detailsModel from "../../../Editor/detailsModel";
import { Typography } from "@mui/material";
import useAccountSettings from "../../../ManageAccount/useAccountSettings";

function SurveyButtonDialog(props) {
  const { open, handleClose } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const { accountSettings } = useAccountSettings();

  //surveyButton
  const getButtonSurvey = () => {
    let survey = detailsModel();
    survey.itemExtra.interactionType = 1;
    survey.fullQuestion = t("create.newButton");
    survey.items = [];
    return survey;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="create-dialog"
      fullWidth
      maxWidth={"sm"}
      sx={{ maxWidth: "sm", margin: "auto" }}
    >
      <DialogTitle>{t("create.newSurveyButton")}</DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={6}>
            <ButtonBase
              component={Link}
              to={{
                pathname: "/editor",
                state: {
                  from: "surveys",
                  interactionId: "new",
                  interaction: getButtonSurvey(),
                },
              }}
              style={{ width: "100%" }}
            >
              <div
                style={{
                  width: "100%",
                  height: theme.spacing(20),
                  display: "flex",
                  flexWrap: "wrap",
                  gap: theme.spacing(1),
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgba(0,0,0,0.2)",
                  borderRadius: theme.shape.borderRadius,
                }}
              >
                <AddCircleOutlineOutlinedIcon />
                <Typography variant="body2">{t("surveys.blank")}</Typography>
              </div>
            </ButtonBase>
          </Grid>
          <Grid item xs={6}>
            <ButtonBase
              style={{ width: "100%" }}
              component={Link}
              to={{
                pathname: accountSettings.disablePublicLibrary
                  ? "/library/contexts"
                  : "/library/public",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: theme.spacing(20),
                  display: "flex",
                  flexWrap: "wrap",
                  gap: theme.spacing(1),
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgba(0,0,0,0.2)",
                  borderRadius: theme.shape.borderRadius,
                }}
              >
                <CollectionsBookmarkOutlinedIcon />
                <Typography variant="body2">
                  {t("surveys.fromLibary")}
                </Typography>
              </div>
            </ButtonBase>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}

export default SurveyButtonDialog;
